// gimme: conversations-inbox-ui 06/10/2020 24a2e66917cc934433dd111db7e06fd02943ca6a
'use es6';

import { connect } from 'react-redux';
import { restoreCommonMessage } from '../../thread-histories/actions/restoreCommonMessage';
const mapStateToProps = () => ({});
const mapDispatchToProps = {
  onRestore: restoreCommonMessage
};
export const withOnRestore = connect(mapStateToProps, mapDispatchToProps);